import _ from 'underscore';
import queryString from 'query-string';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
  FetchPolicy,
} from '@bingads-webui-react/overreact';
import type { RequestFactoryContext } from '@bingads-webui-react/overreact';

import { schema } from '../../../environment/schema';
import { getDefaultOptions } from '../../../request-contract-helper/index';
import type { Customer, CustomerVariables } from '../../../types';

function ccUrlFactory(params: RequestFactoryContext<CustomerVariables, null>) {
  const { variables } = params;

  const {
    locator,
  } = variables;

  const { descriptor } = locator;
  const { uid, cid } = descriptor;

  const search = {
    uid,
    cid,
    id: cid,
  };

  const searchString = _.isEmpty(search) ? '' : `?${queryString.stringify(search)}`;

  return `cc/API/Customer${searchString}`;
}

function ccOptionsFactory() {
  return getDefaultOptions();
}

export const fetchRequestContract = createRequestContract<CustomerVariables, null>({
  schema,
  dataPath: 'user:customer',
  verb: requestVerbs.GET,
  fetchPolicy: FetchPolicy.StoreOrNetwork,
  uriFactoryFn: ccUrlFactory,

  headerFactoryFn: ccOptionsFactory,

  keySelector: variables => variables.locator.descriptor.cid,

  parentKeySelector: variables => variables.locator.descriptor.uid,
});

export const fetchResponseContract = createResponseContract<
  CustomerVariables,
  null,
  Customer,
  Customer,
  Customer
>({
  requestContract: fetchRequestContract,
  responseType: responseTypes.ENTITY,

  keySelector: customer => customer.id,
  processorFn: response => response,
});
